
import { defineComponent } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import Button2 from '@/components/Button2/index.vue'

export default defineComponent({
  name: 'Prize',
  inheritAttrs: false,
  components: { Button2 },
  props: {
    groupId: {
      type: String,
      default: ''
    },
    playTimes: {
      type: Number,
      default: 0
    }
  },
  setup(props, { emit }) {
    const router = useRouter()
    function switchPrizeIndex(typeName: String) {
      router.push({
        name: typeName.toString()
      })
    }
    return {
      switchPrizeIndex
    }
  }
})
